// markSuggestionApplied — record that a suggestion was applied without
// calling the creation function. Used by NewTicketModal / NewBookingModal
// after the user saves a pre-filled suggestion through the native modal.
// Shares the fingerprint + applied_items logic with applySuggestion.js but
// skips the actual creation step.

import { getSDK } from '@symbo-ls/workspace-shared/functions/sdk.js'
import { fingerprintSuggestion, pruneStaleApplied } from './meetUtils.js'

export const markSuggestionApplied = async function (bucket, item, targetId) {
  const root = this.state.root
  if (!bucket || !item || !targetId) return
  // Only write if the analysis row exists — otherwise there's no DB row to
  // patch. This can happen if the user opens a suggestion modal while still
  // loading the transcript page.
  if (!root.analysis || !root.activeRoomId) return
  try {
    const fingerprint = await fingerprintSuggestion(item)
    const current = root.analysis?.applied_items || []
    const pruned = await pruneStaleApplied(current, root.analysis?.suggestions)
    // Skip if already marked (e.g. double-save race)
    if (pruned.some((e) => e.fingerprint === fingerprint)) return
    const next = [
      ...pruned,
      {
        bucket,
        fingerprint,
        target_id: String(targetId),
        applied_at: new Date().toISOString()
      }
    ]
    // migrated 2026-04-27 to SDK route workspaceProject.meet.analysisAppliedItems
    try {
      await getSDK().execute('workspaceProject.meet.analysisAppliedItems', 'update',
        { roomId: root.activeRoomId, payload: { applied_items: next } })
      root.update({ analysis: { ...root.analysis, applied_items: next } })
    } catch (err) {
      console.warn('[markSuggestionApplied] write failed', err?.message || err)
    }
  } catch (err) {
    console.warn('[markSuggestionApplied] skipped', err)
  }
}
